<template>
    <el-dialog :visible.sync="openDialog" :append-to-body="true" custom-class="select-gys-dialog" @closed="closed" width="calc(100% - 40px)" top="20px" :title="title" :close-on-click-modal="false">
        <div class="select-wrap">
            <div class="select-wrap-left">
                <div class="tree-box">
                    <el-tree
                        ref="treeRef"
                        :data="treeData"
                        :highlight-current="true"
                        :current-node-key="selectTreeId"
                        :expand-on-click-node="false"
                        node-key="id"
                        :props="defaultProps"
                        @node-click="treeNodeClick"
                    ></el-tree>
                </div>
            </div>
            <div class="select-wrap-right">
                <div class="top-search">
                    <el-input size="mini" placeholder="请输入关键字查询" clearable v-model="quertInfo.objMap.keyword" style="width: 160px" prefix-icon="el-icon-search"></el-input>
                    <el-button size="mini" type="primary" @click="onSearch" style="margin-left:10px">搜索</el-button>
                </div>
                <div class="table-box">
                    <el-table :data="tableData" border size="mini" ref="tableRef" :class="[orderInfo.xjFs == 2?'hide-fx':'']" :height="`393px`" :header-cell-style="headerCellStyle" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="40" align="left" v-if="orderInfo.xjFs != 2"> </el-table-column>
                        <el-table-column label="选择" align="center" width="60" v-if="orderInfo.xjFs == 2">
                            <template slot-scope="scope">
                                <el-radio :label="scope.row.id" v-model="radio" @change="getCurrentRow(scope.row)"></el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="企业名称" :show-overflow-tooltip="true"></el-table-column>
                        <el-table-column prop="tyShXxCode" label="统一社会信息代码" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="qyTyoe" label="企业类型" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="taxpayerSign" label="纳税人标识" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="manageArea" label="经营范围" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="zyClass" label="主营品类" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="jyXz" label="经营性质" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="hyType" label="行业类型" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="shFwScope" label="送货范围" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="gsGw" label="公司官网" :show-overflow-tooltip="true"> </el-table-column>
                    </el-table>
                </div>
                <div class="pagination-box">
                    <pagination v-show="count>0" size="mini"
                        @on-pagination="onPagination"
                        :page.sync="quertInfo.page"
						layout="total, prev, pager, next"
                        :limit.sync="quertInfo.limit"
                        :total="count"
                    >
					</pagination>
                </div>
                <div class="select-view">
                    <h3>当前已选供应商：</h3>
                    <div class="gys-names">
                        <el-tag  v-for="user in selecGys" :key="user.id" style="margin-right:5px;margin-bottom:5px;">
                            {{user.name}}
                            <span v-if="user.cname">({{user.cname}})</span>
                            <i class="el-icon-delete" @click="delGys(user)" style="cursor: pointer;margin-left:5px"></i>
                        </el-tag>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitForm()" size="small">确认选择</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { queryByParentId } from '@/api/gysmng/index.js';
import { supplierInfoList } from '@/api/gys/supplierInfo.js'
export default {
    props:['orderInfo'],
    data(){
        return {
            title:'选择供应商',
            openDialog:false,
            treeData:[],
            selectTreeId:'',
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            count: 0,
			quertInfo: {
				page: 1, //当前页码
				limit: 10, //当前每页显示的数量
				objMap: {
                    supplierClassificationId:"",
                    keyword:'',
					status:2
				}
            },
            tableData:[],
            selecGys:[],
            selecGysObj:{},
            getListFlag:false,
            radio:'',
            radioGys:'',
        }
    },
    created(){
        // this.init()
    },
    methods:{
        init(){
            this.openDialog = true;
            this.getGysClass();
        },
        // 确认选择
        submitForm(){
            if(this.selecGys.length){
                this.$emit('callback',{type:'selgys',info:this.selecGys})
            }else{
                this.$warn('请至少选择一个供应商')
            }
        },
        closed(){
            this.selectTreeId='';
            this.count=0;
            this.quertInfo.page = 1;
            this.quertInfo.objMap = {
                supplierClassificationId:"",
                keyword:'',
                status:2
            };
            this.treeData=[];
            this.tableData=[];
            this.selecGys=[];
            this.selecGysObj={};
            this.getListFlag=false;
        },
        // 获取供应商分类
        async getGysClass(){
            let _this = this;
            const { data: res } = await queryByParentId({})
            if (res.code == 0) {
                let treeData = res.data||[];
                if(treeData[0]){
                    treeData[0]['name'] = '全部';

                }
                this.treeData = treeData;
                _this.$nextTick(()=>{
                    if(_this.treeData.length>0){
                        _this.$refs.treeRef.setCurrentKey(treeData[0].id+'');
                        _this.selectTreeId = treeData[0].id+'';
                    }
                })

            }
        },
        // 点击树
        treeNodeClick(data){
            let _this = this;
            _this.$refs.treeRef.setCurrentKey(data.id+'');
            _this.selectTreeId = data.id+'';
        },
        onSearch(){
            this.quertInfo.page = 1;
            this.getGysList()
        },
        async getGysList() {
			let _this = this;
            this.getListFlag = true;
            this.$nextTick(async ()=>{
                const { data: res } = await supplierInfoList(_this.quertInfo)
                if (res.code == 0) {
                    _this.tableData = res.data||[];
                    _this.count = res.count;
                    if(this.orderInfo.xjFs == 2){ return  }// 定向询价
                    this.$nextTick(()=>{
                        this.tableData.forEach((item)=>{
                            if(this.selecGysObj[`id_${item.id}`]){
                                console.log('勾选')
                                console.log(item)
                                this.$refs.tableRef.toggleRowSelection(item,true);// 选中
                            }
                        })
                        this.getListFlag = false;
                    })
                }
            })
        },
        onPagination: function (val) {
			this.quertInfo.page = val.page;
			this.quertInfo.limit = val.limit;
			this.getGysList();
		},
        // 单选
        getCurrentRow(row){
            this.radio = row.id;
            this.selecGys = [row];
        },
        // 勾选
        handleSelectionChange(val) {
            console.log('触发勾选逻辑')
            console.log(val)
            if(this.getListFlag){
                return
            }
            // if(this.orderInfo.xjFs == 2){   // 定向采购 只能选一个供应商
            //     // this.selecGys =[...newList];
            //     if(val.length == 1){
            //         console.log('1111')
            //         this.selecGys = val
            //         this.selecGysObj[`id_${val[0].id}`] =true;
            //     }else if(val.length == 2){
            //         console.log('2222')
            //         val.forEach((item)=>{
            //             if(this.selecGysObj[`id_${item.id}`]){
            //                 this.$refs.tableRef.toggleRowSelection(item,false);// 取消选中
            //             }else{
            //                 this.$refs.tableRef.toggleRowSelection(item,true);// 取消选中
            //             }
            //         })
            //         // this.selecGys = val
            //         // this.selecGysObj[`id_${val[0].id}`] =true;
            //     }else{
            //         console.log('333')
            //         this.selecGys = []
            //         this.selecGysObj = {}
            //     }
            //     return
            // }
            this.selecGysObj = {};
            // 分离出来当前表格选择和未选中的
            let selItems = [];
            let curPageSel = {};    // 当前选中
            let curPageunSel = {};  // 当前未选中

            // 获取已选择标志
            for (let item of val) {
                curPageSel[`id_${item.id}`] = true;
                selItems.push(item);
            }
            // 获取未选择标志
            this.tableData.forEach((item)=>{
                if(!curPageSel[`id_${item.id}`]){
                    curPageunSel[`id_${item.id}`] = true
                }
            })

            let oldSelectList = [...this.selecGys];
            let newList = [];
            // 剔除当前页面对应未选中的
            oldSelectList.forEach((list)=>{
                if(!curPageunSel[`id_${list.id}`]){
                    newList.push(list);
                    this.selecGysObj[`id_${list.id}`] = true;
                }
            })
            // 查看选中的 是都还有未放到数组里的 放进来
            selItems.forEach((item)=>{
                if(!this.selecGysObj[`id_${item.id}`]){
                    newList.push(item);
                    this.selecGysObj[`id_${item.id}`] = true;
                }
            })
            this.selecGys =[...newList];
            console.log(this.selecGys)
            console.log(this.selecGysObj)
        },
        // 删除已选供应商
        delGys(info){
            if(this.orderInfo.xjFs == 2){   // 定向询价
                this.radio = '';
                this.selecGys = [];
                return
            }
            let run = false;
            this.tableData.forEach((item)=>{
                if(item.id == info.id){
                    console.log(item);
                    run = true;
                    this.$refs.tableRef.toggleRowSelection(item,false);// 取消选中
                }
            });
            // 删除的公司不属于当前表格
            if(!run){
                this.selecGysObj[`id_${info.id}`] = false;
                let newList = [];
                this.selecGys.forEach((item)=>{
                    if(item.id != info.id){
                        newList.push(item)
                    }
                });
                this.selecGys = [...newList]
            }
        }
    },
    watch:{
        'selectTreeId':function(val){
            console.log(val)
            this.quertInfo.objMap.supplierClassificationId = val;
            if(val == 1){
                this.quertInfo.objMap.supplierClassificationId = '';
            }
            this.quertInfo.objMap.keyword = '';
            this.$nextTick(()=>{
                this.onSearch();
            })
        },
    }
}
</script>
<style lang="scss">
    .select-gys-dialog{
        margin-bottom: 20px;
        .hide-fx{
            th{
                .el-checkbox{
                    display: none;
                }
            }
            .el-radio__label{
                display: none;
            }
        }
        .select-wrap{
            width: 100%;
            height: calc(100vh - 160px);
            display: flex;
            justify-content: space-between;
            .select-wrap-left{
                width: 260px;
                padding-right: 20px;
                border-right: 1px solid #e8e8e8;
                height: calc(100vh - 160px);
                overflow-y: auto;
            }
            .select-wrap-right{
                flex: 1;
                padding: 0 10px;
                overflow-y: auto;
                overflow-x: hidden;
                display: flex;
                flex-direction: column;
                .pagination-box{
                    width: 100%;
                    text-align: right;
                }
                .table-box{
                    margin: 10px 0;
                    min-height: 400px;
                    overflow: hidden;
                }
                .select-view{
                    flex: 1;
                    margin-top: 10px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    h3{
                        font-size: 14px;
                        line-height: 20px;
                    }
                    .gys-names{
                        flex: 1;
                        border: 1px solid #e8e8e8;
                        border-radius: 5px;
                        margin-top: 10px;
                        min-height: 100px;
                        overflow-y: auto;
                        padding: 10px;
                    }
                }
            }
        }
    }
</style>
